var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "progress-bar",
      style: { "grid-template-columns": "repeat(" + _vm.totalSteps + ", 1fr)" }
    },
    _vm._l(_vm.totalSteps, function(step) {
      return _c("div", {
        key: step,
        staticClass: "step",
        class: { "step--completed": step <= _vm.stepsCompleted }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7c0e756", { render: render, staticRenderFns: staticRenderFns })
  }
}